import { addFavorite, deleteFavorite } from 'core/actions/member';

export const favoriteIconClick = (merchantId, isFavorited, forceSkipFirstFavoritesPopup = false) => (
  isFavorited ? deleteFavorite(merchantId) : addFavorite(merchantId, {}, {}, { forceSkipFirstFavoritesPopup })
);
